<template>
  <v-card
    width="100%"
    :color="color"
    :class="classes"
    :height="height"
    :dark="value"
    :style="styleAttrs"
  >
    <v-checkbox
      class="checkbox"
      :on-icon="onIcon"
      :off-icon="offIcon"
      :color="iconColor"
      :input-value="value"
      @change="$emit('change', $event)"
    />

    <div class="content">
      <div :class="{label: true, outlined: !value}">
        {{ label }}
      </div>

      <div v-if="description" :class="{description: true, outlined: !value}">
        {{ description }}
      </div>
    </div>

    <z-icon
      class="remove-icon"
      :color="iconColor"
      @click="$emit('click:remove', $event)"
    >
      {{ removeIcon }}
    </z-icon>
  </v-card>
</template>

<script>
/**
 * @private
 */
export default {
  props: {
    label: {
      type: String,
    },

    styleAttrs: {
      type: Object,
      default: () => ({}),
    },

    description: {
      type: String,
    },

    value: {
      type: Boolean,
      default: false,
    },

    height: {
      type: [Number, String],
      default: 60,
    },

    onIcon: {
      type: String,
      default: '$check_box_rounded',
    },

    offIcon: {
      type: String,
      default: '$check_box_outline_blank_rounded',
    },

    removeIcon: {
      type: String,
      default: '$remove_circle_outline_rounded',
    },
  },

  computed: {
    iconColor() {
      return this.value ? 'white' : 'primary'
    },
    color() {
      return this.value ? 'primary' : 'white'
    },
    classes() {
      return {
        'zoox-group-select': true,
        outlined: !this.value,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'style';

.zoox-group-select {
  @extend %zoox-group-select;

  grid-template-columns: 45px auto 30px;
}
</style>
